<template>
  <div class="max-w-5xl mx-auto px-4">
    <p v-if="location.address">Address: {{ location.address }}</p>
    <p class="addressText" v-else>No address available.</p>
    <form @submit.prevent="handleSubmit">
        <h4 class="playerHeading">Big 2 Players</h4>
      <div class="checkbox-group">
        
        <div class="checkbox-item" v-for="player in ['Bailey', 'Daniel', 'Ivan', 'Jason', 'Josh', 'Kulin', 'Nath', 'Vic', 'Vis', 'Wong', 'Xinzun', 'Zheng']" :key="player">
          <input 
            type="checkbox" 
            :id="'players-' + player.toLowerCase()" 
            v-model="formData.players" 
            :value="player"
            class="appearance-none w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500 focus:ring-2 checked:bg-red-600 checked:border-red-600 cursor-pointer"
          >
          <label :for="'players-' + player.toLowerCase()">{{ player }}</label>
        </div>

        <div class="checkbox-item">
          <input type="checkbox" id="players-custom" v-model="formData.players" :value="sanitizeInput(customPlayerName)" class="appearance-none w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500 focus:ring-2 checked:bg-red-600 checked:border-red-600 cursor-pointer" />
          <input type="text" v-model="customPlayerName" placeholder="Player Name" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-red-500 focus:border-red-500 p-1"/>
        </div>

        <div class="checkbox-item">
          <input type="checkbox" id="players-custom2" v-model="formData.players" :value="sanitizeInput(customPlayerName2)" class="appearance-none w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500 focus:ring-2 checked:bg-red-600 checked:border-red-600 cursor-pointer" />
          <input type="text" v-model="customPlayerName2" placeholder="Player Name" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-red-500 focus:border-red-500 p-1" />
        </div>

        <div class="checkbox-item">
          <input type="checkbox" id="players-custom3" v-model="formData.players" :value="sanitizeInput(customPlayerName3)" class="appearance-none w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500 focus:ring-2 checked:bg-red-600 checked:border-red-600 cursor-pointer" />
          <input type="text" v-model="customPlayerName3" placeholder="Player Name" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-red-500 focus:border-red-500 p-1" />
        </div>
      </div>

      <div class="dropdown-group">
        <div class="select-container">
          <h4>Winner</h4>
          <div>
            <select id="winner-dropdown" v-model="formData.winner" class="appearance-none bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-red-500 focus:border-red-500 block w-[80%] mx-auto p-2 cursor-pointer">
              <option v-for="player in formData.players" :key="player" :value="player">{{ player }}</option>
            </select>
          </div>
        </div>
        
        <div class="select-container">
          <h4>Second</h4>
          <div>
            <select id="second-dropdown" v-model="formData.second" class="appearance-none bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-red-500 focus:border-red-500 block w-[80%] mx-auto p-2 cursor-pointer">
              <option v-for="player in formData.players" :key="player" :value="player">{{ player }}</option>
            </select>
          </div>
        </div>
        
        <div class="select-container">
          <h4>Third</h4>
          <div>
            <select id="third-dropdown" v-model="formData.third" class="appearance-none bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-red-500 focus:border-red-500 block w-[80%] mx-auto p-2 cursor-pointer">
              <option v-for="player in formData.players" :key="player" :value="player">{{ player }}</option>
            </select>
          </div>
        </div>
        
        <div class="select-container">
          <h4>Loser</h4>
          <div>
            <select id="loser-dropdown" v-model="formData.loser" class="appearance-none bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-red-500 focus:border-red-500 block w-[80%] mx-auto p-2 cursor-pointer">
              <option v-for="player in formData.players" :key="player" :value="player">{{ player }}</option>
            </select>
          </div>
        </div>
      </div>
     
      <button type="submit" class="text-white bg-red-600 hover:bg-red-700 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-2 border-none cursor-pointer">Submit</button>
    </form>
  </div>

  <div id="postMessage">
    <p v-if="successMessage">{{ successMessage }}</p>
    <p v-if="validationMessage" class="text-red-600 font-bold">{{ validationMessage }}</p> 
  </div>
</template>

<script>
import DOMPurify from 'dompurify';
import axios from 'axios';

// Set Axios defaults for CSRF protection and credentials
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.withCredentials = true;

export default {
  data() {
    return {
      formData: {
        players: [],
        winner: "",
        second: "",
        third: "",
        loser: "",
        location: "",
      },
      customPlayerName: "", 
      customPlayerName2: "",
      customPlayerName3: "",
      successMessage: "", 
      validationMessage: "",
      location: {
        latitude: null,
        longitude: null,
        address: null,
      },
    };
  },
  computed: {
    isFormValid() {
      return (
        this.formData.players.includes(this.formData.winner) &&
        this.formData.players.includes(this.formData.second) &&
        this.formData.players.includes(this.formData.third) &&
        this.formData.players.includes(this.formData.loser) &&
        this.formData.winner !== this.formData.second &&
        this.formData.winner !== this.formData.third &&
        this.formData.winner !== this.formData.loser &&
        this.formData.second !== this.formData.third &&
        this.formData.second !== this.formData.loser &&
        this.formData.third !== this.formData.loser
      );
    },
  },
  created() {
    document.title = 'Big 2 Form'; 
    this.getLocation()
      .then(() => {
        this.reverseGeocode();
      })
      .catch((error) => {
        console.error('Error getting location:', error);
      });
  },
  watch: {
  'formData.players': {
    handler() {
      this.sortPlayersAlphabetically();
    },
    deep: true, 
    },
    'location.address': {
    handler() {
      this.formData.location = this.location.address;
    },
    deep: true, 
    },
  },
  
  methods: {
    handleSubmit() {
      if (this.formData.players.length !== 4) {
        this.successMessage = ""; 
        this.validationMessage = "Please select exactly 4 players."; 
        return; 
      }

      for (const playerName of this.formData.players) {
        if (!/^[A-Za-z ]+$/.test(playerName)) {
          this.successMessage = "";
          this.validationMessage = "Please enter player names with only letters.";
          return; 
        }
      }

      if(!this.isFormValid && this.formData.players.length == 4) {
        this.successMessage = "";
        this.validationMessage = "Please select valid winner and loser from the players list or you can't select the same person multiple times.";
        return; 
      }
      
      axios
        .post('/api/big2-statistics/', this.formData)
        .then((response) => {
          this.successMessage = "Data successfully posted"; 
          this.validationMessage = ""; 
          console.log("Data successfully posted", response.data);

          this.formData.winner = "";
          this.formData.second = "";
          this.formData.third = "";
          this.formData.loser = "";

          setTimeout(() => {
            this.successMessage = "";
          }, 1500);
        })
        .catch((error) => {
          console.error("Error:", error);
          this.successMessage = ""; 
        });
    },

    sanitizeInput(input) {
      return DOMPurify.sanitize(input);
    },

    getLocation() {
      return new Promise((resolve, reject) => {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              this.location.latitude = position.coords.latitude;
              this.location.longitude = position.coords.longitude;
              resolve(); 
            },
            (error) => {
              console.error('Error getting location:', error);
              reject(error); 
            }
          );
        } else {
          console.error('Geolocation is not supported in this browser.');
          reject(new Error('Geolocation not supported')); 
        }
      });
    },

    async reverseGeocode() {
      const { latitude, longitude } = this.location;
      try {
        const response = await axios.get(
          `/api/reverse-geocode/?latitude=${latitude}&longitude=${longitude}`
        );
        if (response.data.status === 'OK') {
          const formattedAddress = response.data.results[0].formatted_address;
          this.location.address = formattedAddress;
        } else {
          console.error('Reverse geocoding request failed:', response.data.status);
        }
      } catch (error) {
        console.error('Error reverse geocoding:', error);
      }
    },

    sortPlayersAlphabetically() {
      this.formData.players.sort((a, b) => {
        return a.localeCompare(b); 
      });
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: 'Formula1-Regular';
  src: url('@/assets/fonts/Formula1-Regular.otf') format('opentype'); 
}

@font-face {
  font-family: 'Formula1-Bold';
  src: url('@/assets/fonts/Formula1-Bold.otf') format('opentype'); 
}

.addressText{
  font-family: 'Formula1-Regular', sans-serif;
  font-size: 12px;
}

.playerHeading{
  font-family: 'Formula1-Bold', sans-serif;
  font-size: 16px;
  margin-top: -10px;
  margin-bottom: 30px;
}

input[type="text"] {
  width: 80px;
  display: block;
  margin-left: 10px;
  margin-bottom: 12px;
  text-align: center;
  font-family: 'Formula1-Regular', sans-serif;
  font-size: 10px;
}

/* Removed the manual checkbox sizing so Tailwind can handle it perfectly! */

form {
  border: 1px solid #ccc; 
  border-radius: 25px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); 
  padding: 20px 0; 
  transition: box-shadow 0.3s ease; 
  font-family: 'Formula1-Regular', sans-serif;
  font-size: 12px;
}

form:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3); 
}
.checkbox-group {
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  max-width: 400px; 
}

.checkbox-item {
  flex: 0 0 calc(33.33% - 10px); 
  margin-right: 5px; 
  margin-left: 5px;
  margin-bottom: 12px;
  border-bottom: 1px solid #ccc; 
}

label {
  display: block;
  margin-bottom: 5px; 
}

.dropdown-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around; 
}

.select-container {
  flex: 0 0 calc(50% - 10px); 
  margin-bottom: 10px; 
}

/* Let Tailwind handle the width and border for Selects! */
select {
  font-family: 'Formula1-Regular', sans-serif;
}

h2{
  text-align: center;
  margin-top: -30px;
  margin-bottom: 50px;
}

h4{
  text-align: center;
  margin-top: 12px;
  margin-bottom: 5px;
}

p {
  font-family: 'Formula1-Regular', sans-serif;
  font-size: 12px;
}
</style>